import React, { useEffect, useMemo, useRef, useState } from 'react';
import $ from 'jquery';
import { Icon } from '@iconify/react';
import { useUserProfile } from '../masterLayout/MasterLayoutBody';
import { useFormBuilder } from '../utils/useFormBuilder';
import { validateForm } from '../utils/useValidator';
import { getPlantRateCategoryTemplates, createPlantRateCategories, updatePlantRateCategories, deletePlantRateCategories } from '../api/plant-rate-categoriesAPI';
import { getPlantRateFluids, createPlantRateFluids, updatePlantRateFluids, deletePlantRateFluids } from '../api/plant-rate-fluidsAPI';
import { getPlantRateGlobals, createPlantRateGlobals, updatePlantRateGlobals, deletePlantRateGlobals } from '../api/plant-rate-globalsAPI';
import { getPlantRateGETTemplates, createPlantRateGroundTools, updatePlantRateGroundTools, deletePlantRateGroundTools } from '../api/plant-rate-ground-toolsAPI';
import { getPlantRateTyreTemplates, createPlantRateTyres, updatePlantRateTyres, deletePlantRateTyres } from '../api/plant-rate-tyresAPI';
import { getExpenseCodes } from '../api/expense-codeAPI';
import { getCurrency } from '../api/currencyAPI';
import { getGroups } from '../api/groupAPI';
import { getPlantRateFluidList } from '../api/plant-rate-fluid-listAPI';

const tableConfigs = [
  {
    key: 'categories',
    label: 'Plant Rate Categories',
    recordName: 'Category',
    fields: [
      { field: 'name', label: 'Name', type: 'text', size: '6', required: true },
      { field: 'description', label: 'Description', type: 'textarea', size: '6' },
      { field: 'defaultExpense', label: 'Default Expense', type: 'select', size: '6' },
    ],
    api: { get: getPlantRateCategoryTemplates, create: createPlantRateCategories, update: updatePlantRateCategories, delete: deletePlantRateCategories },
  },
  {
    key: 'fluids', label: 'Plant Rate Categories', recordName: 'Fluid Template',
    filterTemplate: true,
    fields: [
      { field: 'partNumber', label: 'Part Number', type: 'text', size: '6' }, { field: 'name', label: 'Name', type: 'text', size: '6', required: true },
      { field: 'life', label: 'Life', type: 'number', size: '4' }, { field: 'cost', label: 'Cost', type: 'number', size: '4' }, { field: 'currencyId', label: 'Currency', type: 'select', size: '4' },
      { field: 'quantity', label: 'Quantity', type: 'number', size: '4' }, { field: 'groupId', label: 'Group', type: 'select', size: '4' }, { field: 'templateName', label: 'Template Name', type: 'text', size: '4' },
      { field: 'topUpPercent', label: 'Top Up %', type: 'number', size: '4' },
      { field: 'fluidItemId', label: 'Fluid Item', type: 'select', size: '6' },
    ],
    api: { get: getPlantRateFluids, create: createPlantRateFluids, update: updatePlantRateFluids, delete: deletePlantRateFluids },
  },
  {
    key: 'globals', label: 'Plant Rate Global Parameters', recordName: 'Global Parameter',
    fields: [
      { field: 'interestRate', label: 'Interest Rate', type: 'number', size: '4', required: true },
      { field: 'insuranceRate', label: 'Insurance Rate', type: 'number', size: '4', required: true },
      { field: 'fuelPrice', label: 'Fuel Price', type: 'number', size: '4', required: true },
      { field: 'technicianRate', label: 'Technician Rate', type: 'number', size: '6', required: true },
      { field: 'operatorRate', label: 'Operator Rate', type: 'number', size: '6', required: true },
    ],
    api: { get: getPlantRateGlobals, create: createPlantRateGlobals, update: updatePlantRateGlobals, delete: deletePlantRateGlobals },
  },
  {
    key: 'ground-tools', label: 'Plant Rate GET Templates', recordName: 'GET Template',
    filterTemplate: true,
    fields: [
      { field: 'partNumber', label: 'Part Number', type: 'text', size: '6' }, { field: 'name', label: 'Name', type: 'text', size: '6', required: true },
      { field: 'life', label: 'Life', type: 'number', size: '4' }, { field: 'cost', label: 'Cost', type: 'number', size: '4' }, { field: 'currencyId', label: 'Currency', type: 'select', size: '4' },
      { field: 'quantity', label: 'Quantity', type: 'number', size: '4' }, { field: 'groupId', label: 'Group', type: 'select', size: '4' }, { field: 'templateName', label: 'Template Name', type: 'text', size: '4' },
    ],
    api: { get: getPlantRateGETTemplates, create: createPlantRateGroundTools, update: updatePlantRateGroundTools, delete: deletePlantRateGroundTools },
  },
  {
    key: 'tyres', label: 'Plant Rate Tyre Templates', recordName: 'Tyre Template',
    fields: [
            { field: 'numberOfTyres', label: 'Number Of Tyres', type: 'number', size: '4' }, { field: 'tyreLife', label: 'Tyre Life', type: 'number', size: '4' },
      { field: 'tyreCost', label: 'Tyre Cost', type: 'number', size: '4' }, { field: 'rimLife', label: 'Rim Life', type: 'number', size: '4' }, { field: 'rimCost', label: 'Rim Cost', type: 'number', size: '4' },
      { field: 'fuelUsage', label: 'Fuel Usage', type: 'number', size: '4' }, { field: 'fuelType', label: 'Fuel Type', type: 'number', size: '4' }, { field: 'notes', label: 'Notes', type: 'textarea', size: '12' },
    ],
    api: { get: getPlantRateTyreTemplates, create: createPlantRateTyres, update: updatePlantRateTyres, delete: deletePlantRateTyres },
  },
];

const PlantManagementTablesLayer = ({ visibleKeys }) => {
  const userProfile = useUserProfile();
  const scopedConfigs = useMemo(() => tableConfigs.filter((c) => !visibleKeys || visibleKeys.includes(c.key)), [visibleKeys]);
  const [activeTab, setActiveTab] = useState(scopedConfigs[0]?.key || tableConfigs[0].key);
  const config = scopedConfigs.find((c) => c.key === activeTab) || scopedConfigs[0];
  const [rows, setRows] = useState([]);
  const [formData, setFormData] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [expenseCodes, setExpenseCodes] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [groups, setGroups] = useState([]);
  const [fluidItems, setFluidItems] = useState([]);
  const tableRef = useRef(null);
  const dtRef = useRef(null);

  const expenseOptions = useMemo(() => expenseCodes.map((e) => ({ value: e.id, label: e.name })), [expenseCodes]);
  const currencyOptions = useMemo(() => currencies.map((c) => ({ value: c.id, label: `${c.name || c.currency || ''} (${c.symbol || ''})`.trim() })), [currencies]);
  const groupOptions = useMemo(() => groups.map((g) => ({
    value: g.id,
    label: `${g.manufacturer?.manufacturername || ''} ${g.name || ''} ${g.class?.classname || ''}`.replace(/\s+/g, ' ').trim(),
  })), [groups]);
  const fluidItemOptions = useMemo(() => fluidItems.map((item) => ({
    value: item.id,
    label: `${item.manufacturerType?.name || ''} ${item.name || ''} ${item.productCode || ''}`.replace(/\s+/g, ' ').trim(),
  })), [fluidItems]);

  const configuredFields = useMemo(() => config.fields.map((f) => {
    if (f.field === 'defaultExpense') return { ...f, options: expenseOptions };
    if (f.field === 'currencyId') return { ...f, options: currencyOptions };
    if (f.field === 'groupId') return { ...f, options: groupOptions };
    if (f.field === 'fluidItemId') return { ...f, options: fluidItemOptions };
    return f;
  }), [config, expenseOptions, currencyOptions, groupOptions, fluidItemOptions]);

  const { renderField } = useFormBuilder(configuredFields, formData, setFormData, errors);

  const fieldsForTable = useMemo(() => configuredFields.filter((f) => f.field !== 'id' && f.field !== 'template'), [configuredFields]);
  const canCreate = userProfile?.privileges?.includes('plant-rates:create');
  const canUpdate = userProfile?.privileges?.includes('plant-rates:update');
  const canDelete = userProfile?.privileges?.includes('plant-rates:delete') || userProfile?.privileges?.includes('plant-rate:delete');

  const fetchRows = async () => {
    const data = await config.api.get();
    setRows(data || []);
  };

  useEffect(() => { fetchRows(); }, [activeTab]);
  useEffect(() => {
    getExpenseCodes().then(setExpenseCodes);
    getCurrency().then(setCurrencies);
    getGroups().then(setGroups);
    getPlantRateFluidList().then((data) => setFluidItems(data || []));
  }, []);
  useEffect(() => {
    if (dtRef.current) dtRef.current.destroy();
    if (rows.length > 0) dtRef.current = $(tableRef.current).DataTable({ pageLength: 25, dom: 'rtp' });
    return () => dtRef.current?.destroy(true);
  }, [rows]);
  useEffect(() => { dtRef.current?.search(searchTerm).draw(); }, [searchTerm]);

  const handleSave = async () => {
    const validationErrors = validateForm(configuredFields, formData);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length) return;
    const payload = Object.fromEntries(Object.entries(formData).filter(([k, v]) => k !== 'id' && v !== null && typeof v !== 'object'));
    if (['ground-tools','tyres','fluids'].includes(config.key)) payload.template = 1;
    if (editingId) await config.api.update(editingId, payload); else await config.api.create(payload);
    setShowModal(false); setEditingId(null); setFormData({});
    await fetchRows();
  };

  return <div className='card h-100 p-0 rounded-0'>
    <div className='card-header p-0'>
      <ul className='nav nav-tabs'>
        {scopedConfigs.map((t) => <li key={t.key} className='nav-item'><button className={`nav-link ${activeTab === t.key ? 'active' : ''}`} onClick={() => setActiveTab(t.key)}>{t.label}</button></li>)}
      </ul>
      <div className='d-flex justify-content-between p-3'>
        <input className='form-control w-auto' placeholder='Search...' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
        {canCreate && <button className='btn btn-primary text-sm btn-sm px-16 py-12 radius-4 d-flex align-items-center gap-2' onClick={() => { setFormData(config.filterTemplate ? { template: 1 } : {}); setEditingId(null); setShowModal(true); }}><Icon icon='ic:baseline-plus' className='icon text-xl' />Add {config.recordName}</button>}
      </div>
    </div>
    <div className='card-body p-0'><div className='table-responsive scroll-sm'><table ref={tableRef} className='table bordered-table mb-0 w-100 rounded-0'>
      <thead><tr>{fieldsForTable.map((f) => <th key={f.field}>{f.label}</th>)}<th>Actions</th></tr></thead>
      <tbody>{rows.map((r) => <tr key={r.id || `${r.name}-${r.templateName}`}>
        {fieldsForTable.map((f) => {
          let value = r[f.field];
          if (f.field === 'defaultExpense') value = r.expenseCode?.name || expenseCodes.find((e) => Number(e.id) === Number(r.defaultExpense))?.name || r.defaultExpense;
          if (f.field === 'currencyId') value = r.currency ? `${r.currency.name || r.currency.currency || ''} (${r.currency.symbol || ''})`.trim() : currencyOptions.find((c) => Number(c.value) === Number(r.currencyId))?.label || r.currencyId;
          if (f.field === 'groupId') value = r.group ? `${r.group.manufacturer?.manufacturername || ''} ${r.group.name || ''} ${r.group.class?.classname || ''}`.replace(/\s+/g, ' ').trim() : groupOptions.find((g) => Number(g.value) === Number(r.groupId))?.label || r.groupId;
          return <td key={f.field}>{String(value ?? '')}</td>;
        })}
        <td><div className='d-flex gap-2'>{canUpdate && <button className='w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center' onClick={() => { setEditingId(r.id); setFormData(r); setShowModal(true); }}><Icon icon='ic:baseline-edit' className='icon text-xl line-height-1' /></button>}{canDelete && <button className='w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center' onClick={async () => { if (!window.confirm(`Delete ${config.recordName}?`)) return; await config.api.delete(r.id); await fetchRows(); }}><Icon icon='ic:baseline-delete-outline' className='icon text-xl line-height-1' /></button>}</div></td>
      </tr>)}</tbody>
    </table></div></div>
    {showModal && <div className='modal show d-block' tabIndex='-1'><div className='modal-dialog modal-lg'><div className='modal-content'><div className='modal-header'><h5 className='modal-title'>{editingId ? `Edit ${config.recordName}` : `Add ${config.recordName}`}</h5><button type='button' className='btn-close' onClick={() => setShowModal(false)} /></div><div className='modal-body'><div className='row g-3'>{configuredFields.filter((f) => f.field !== 'id' && f.field !== 'template' && !(config.filterTemplate && f.field === 'template')).map(renderField)}</div></div><div className='modal-footer'><button className='btn btn-secondary' onClick={() => setShowModal(false)}>Close</button><button className='btn btn-primary' onClick={handleSave}>Save</button></div></div></div></div>}
  </div>;
};

export default PlantManagementTablesLayer;
